import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import "../index.css"

import { Dialog } from "primereact/dialog";
import { Button } from '../../../../helpers'

import ReplacementItems from '../../../../common/ReplacementItems'
import DispatchNoteItems from '../../../../common/DispatchNoteItems'
import ReplaceBuyerReqItems from '../../../../common/ReplaceBuyerReqItems'

import { getDuplicatesInArray, round } from '../../../../utils'
import { DECIMAL_LIMIT } from '../../../../constants'
import { raiseToast } from '../../../../services/redux/reducers/toast/toast'


const CreateInvoice = (props) => {
    const { newDispatchNote, userId } = props
    const [reqWiseGroupedDispatchNoteItems, setReqWiseGroupedDispatchNoteItems] = useState({})
    const [buyerReqWiseDispatchNoteItems, setBuyerReqWiseDispatchNoteItems] = useState([])
    const [isReplaceItemsVisible, setIsReplaceItemsVisible] = useState(false)
    const [isReplaceItems, setIsReplaceItems] = useState(false)
    const [replaceBuyerReqItems, setReplaceBuyerReqItems] = useState([])
    const [selectedReplaceBuyerReqItems, setSelectedReplaceBuyerReqItems] = useState([])
    const [selectedReplaceBuyerReqItemIds, setSelectedReplaceBuyerReqItemIds] = useState([])

    const dispatch = useDispatch()

    useEffect(() => {
        if (props.newDispatchNote) {

            let dispatchNoteItems=[]
            let reqWiseDispatchNoteItems = {}
            newDispatchNote?.dispatchNoteItems?.map(eachDispatchNoteItem => {
                dispatchNoteItems.push(eachDispatchNoteItem)
                if (!reqWiseDispatchNoteItems[eachDispatchNoteItem.buyerReqItemId]) {
                    reqWiseDispatchNoteItems[eachDispatchNoteItem.buyerReqItemId] = [];
                }

                reqWiseDispatchNoteItems[eachDispatchNoteItem.buyerReqItemId].push(JSON.parse(JSON.stringify(eachDispatchNoteItem)))

            })

            dispatchNoteItems.map(eachDispatchNoteItem => {
                let relatedBuyerReqDispatchNoteItem = buyerReqWiseDispatchNoteItems.find(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId === eachDispatchNoteItem.buyerReqItemId)
                if(!relatedBuyerReqDispatchNoteItem){
                    eachDispatchNoteItem.totalQty = parseFloat(eachDispatchNoteItem.qty)
                    eachDispatchNoteItem.totalAmount = round(eachDispatchNoteItem.totalQty * eachDispatchNoteItem.unitPrice, DECIMAL_LIMIT)
                    buyerReqWiseDispatchNoteItems.push(JSON.parse(JSON.stringify(eachDispatchNoteItem)))
                }else{
                    relatedBuyerReqDispatchNoteItem.qty = parseFloat(relatedBuyerReqDispatchNoteItem.qty) + parseFloat(eachDispatchNoteItem.qty)
                    relatedBuyerReqDispatchNoteItem.totalQty = parseFloat(relatedBuyerReqDispatchNoteItem.totalQty) + parseFloat(eachDispatchNoteItem.qty)
                    relatedBuyerReqDispatchNoteItem.totalAmount = round(relatedBuyerReqDispatchNoteItem.qty * eachDispatchNoteItem.unitPrice, DECIMAL_LIMIT)
                }
            })
            
            setBuyerReqWiseDispatchNoteItems([...buyerReqWiseDispatchNoteItems])
            setReqWiseGroupedDispatchNoteItems(reqWiseDispatchNoteItems)
        }
    }, [])

    const handleSubmitCreateReplaceProducts = async() => {
        let replaceBuyerReqItems = buyerReqWiseDispatchNoteItems.filter(eachDispatchNoteItem => eachDispatchNoteItem.isReplaced)
        let replacementItems = []
        
        replaceBuyerReqItems.map(eachDispatchNoteItem => {
            
            let replacementBuyerReqObj = {
                companyId : newDispatchNote.companyId,
                HSNCode : eachDispatchNoteItem.HSNCode,
                replaceByName: eachDispatchNoteItem.companyProdName, //eachDispatchNoteItem.productName,
                replaceByDesc: eachDispatchNoteItem.companyProdSpec, //eachDispatchNoteItem.productSpecification,
                persistent :  false,
                createdBy :  userId,
                unitPrice: eachDispatchNoteItem.unitPrice,
                UOM: eachDispatchNoteItem?.UOM
            }

            let replacedBuyerReqItems = {}
            eachDispatchNoteItem.replacedBuyerReqItems.map(eachBuyerReqItem => {
                if(replacedBuyerReqItems.hasOwnProperty(eachBuyerReqItem.materialId)){
                    replacedBuyerReqItems[eachBuyerReqItem.materialId] += round(parseFloat(eachBuyerReqItem.qty)/parseFloat(eachDispatchNoteItem.qty),6)
                }else{
                    replacedBuyerReqItems[eachBuyerReqItem.materialId] = round(eachBuyerReqItem.qty/eachDispatchNoteItem.qty,6)
                }
            })

            replacementBuyerReqObj.toReplace = replacedBuyerReqItems

            let docItemReplacementLog = {
                qtyReplaced: eachDispatchNoteItem.qty,
                createdBy: userId,
                GSTRate: eachDispatchNoteItem.GSTRate,
                unitPrice: eachDispatchNoteItem.unitPrice
            }

            replacementBuyerReqObj.docItemReplacementLog = docItemReplacementLog
            replacementItems.push(replacementBuyerReqObj)
        })

        let isDuplicateMaterialIdReplaced = false
        replacementItems.map(eachReplacedItem => {
            const toReplaceMaterialIds = Object.keys(eachReplacedItem.toReplace)
            toReplaceMaterialIds.map(eachMaterialId => {
                let relatedMaterialItem = buyerReqWiseDispatchNoteItems.find(eachDispatchItem => eachDispatchItem.materialId == eachMaterialId)
                if(relatedMaterialItem){
                    isDuplicateMaterialIdReplaced = true
                }
            })
        })

        function unwindToReplace(array) {
            return _.flatMap(array, item => {
                return _.map(item.toReplace, (value, key) => {
                    return {
                        ...item,
                        toReplace: { [key]: value },
                        uniqueReplaceMaterialId: key
                    }
                })
            })
        }
        let unwoundArray = unwindToReplace(replacementItems)

        const duplicateReplacedItems = getDuplicatesInArray(unwoundArray, ["uniqueReplaceMaterialId"])

        if(duplicateReplacedItems.length > 0){
            isDuplicateMaterialIdReplaced = true
        }

        if(isDuplicateMaterialIdReplaced){
            dispatch(raiseToast({severity: 'error', detail: "Replacement cannot be performed for multiple products with the same material ID."}))
            return
        }

        if (window.confirm("Are you sure you want to continue...?")) {
            props.handleSubmitCreateDispatchWithReplaceProducts(true, replacementItems)
        }
    }

    const handleOnclickShowReplaceItems = () => {
        if (!isReplaceItems) {
            setReplaceBuyerReqItems(JSON.parse(JSON.stringify(buyerReqWiseDispatchNoteItems)))
        } else {
            setSelectedReplaceBuyerReqItemIds([])
            setReplaceBuyerReqItems([])
        }
        setIsReplaceItems(!isReplaceItems)
    }

    const handleBuyerReqReplacementItems = () => {
        let relatedBuyerReqItems = replaceBuyerReqItems.filter(eachBuyerReqItem => selectedReplaceBuyerReqItemIds.includes(eachBuyerReqItem.buyerReqItemId))
        setSelectedReplaceBuyerReqItems(relatedBuyerReqItems)
        setIsReplaceItemsVisible(true)
    }

    const handleReplacementItem = (replacementItem) => {

        let replacementBuyerReqObj = {
            buyerReqItemId: uuidv4(),
            // productName: replacementItem.productName,
            // productSpecification: replacementItem.productSpecification,
            companyProdName: replacementItem.companyProdName,
            companyProdSpec: replacementItem.companyProdSpec,
            GSTRate: replacementItem.GSTRate,
            HSNCode: replacementItem.HSNCode,
            UOM: replacementItem.UOM,
            createdBy: userId,
            qty: replacementItem.qty,
            totalQty: replacementItem.qty,
            unitPrice: replacementItem.unitPrice,
            updatedBy: userId,
            isReplaced: true,
            totalAmount: round(parseFloat(replacementItem.qty * replacementItem.unitPrice), DECIMAL_LIMIT),
            //totalAmount: null,
            persistent: false,
            replacedBuyerReqItems: [...selectedReplaceBuyerReqItems]
        }

        let relatedBuyerReqWiseDispatchNoteItems = buyerReqWiseDispatchNoteItems.map(eachDispatchNoteItem => {
            let relatedReplaceBuyerReqItem = selectedReplaceBuyerReqItems.find(eachReplaceBuyerReqItem => eachReplaceBuyerReqItem.buyerReqItemId === eachDispatchNoteItem.buyerReqItemId)
            if(relatedReplaceBuyerReqItem){
                eachDispatchNoteItem.qty = round(eachDispatchNoteItem.qty - relatedReplaceBuyerReqItem.qty)
                eachDispatchNoteItem.totalAmount = round(eachDispatchNoteItem.qty * eachDispatchNoteItem.unitPrice, DECIMAL_LIMIT)
                if(eachDispatchNoteItem.qty === 0){
                    return null
                }
            }
            return eachDispatchNoteItem
        })
        
        let uniqeBuyerReqWiseDispatchNoteItems = relatedBuyerReqWiseDispatchNoteItems.filter(eachDispatchNoteItem => eachDispatchNoteItem !== null)
        
        setSelectedReplaceBuyerReqItems([])
        setBuyerReqWiseDispatchNoteItems([...uniqeBuyerReqWiseDispatchNoteItems, replacementBuyerReqObj])
        setIsReplaceItems(!isReplaceItems)
        setIsReplaceItemsVisible(false)
        setSelectedReplaceBuyerReqItemIds([])
    }
    
    let displayLabel = false
    
    return (
        <div className="py-2">
            {
                Object.keys(reqWiseGroupedDispatchNoteItems).length > 0 &&
                <>
                    <div className='flex'>
                        <h4 className="ml-2 mr-3 mb-2">Dispatch Note Items</h4>
                        <div>
                            <a style={{ cursor: 'pointer' }} onClick={() => handleOnclickShowReplaceItems()}>
                                {isReplaceItems ? "Click here to buyer invoice items" : "Click here to replace items"}
                            </a>
                        </div>
                    </div>
                    {
                        isReplaceItems ?
                        <>
                            <Button className="small-btn mb-2" label="Replace" disabled={selectedReplaceBuyerReqItemIds.length === 0} onClick={() => handleBuyerReqReplacementItems()} />
                            <div className="p-card col-12 mb-2 xl:col-12 m-0" style={{ padding: 0 }}>
                                <div className="" style={{ paddingLeft: 15, paddingRight: 15 }} >
                                    {
                                        replaceBuyerReqItems?.map((eachBuyerReqItem, index) => {

                                            if (index === 0 && !displayLabel) {
                                                displayLabel = true
                                            }

                                            return (
                                                <ReplaceBuyerReqItems
                                                    buyerReqItem={eachBuyerReqItem}
                                                    displayLabel={displayLabel}
                                                    selectedReplaceBuyerReqItemIds={selectedReplaceBuyerReqItemIds}
                                                    setSelectedInvoiceDispatchNotesIds={setSelectedReplaceBuyerReqItemIds}
                                                    replaceBuyerReqItems={replaceBuyerReqItems}
                                                    setReplaceBuyerReqItems={setReplaceBuyerReqItems}
                                                />
                                            )
                                        }
                                        )}
                                </div>
                            </div>
                            </>
                            :
                            <div className="p-card col-12 mb-2 xl:col-12 m-0" style={{ padding: 0 }} >
                                <div className="" style={{ paddingLeft: 15, paddingRight: 15 }}>
                                    <div>
                                        <div style={{ height: 6 }} ></div>
                                        <div className="mb-1 dispatch-note-items py-1" id={""}>
                                            <div>
                                                <table className="custom-table" style={{ width: "100%" }}>
                                                    <thead >
                                                        <tr className="custom-table-tr">
                                                            <th className="custom-th" >MATERIAL ID</th>
                                                            <th className="custom-th" >PRODUCT DETAILS</th>
                                                            <th className="custom-th" >UOM</th>
                                                            <th className="custom-th" >UNIT PRICE</th>
                                                            <th className="custom-th" >TOTAL QUANTITY</th>
                                                            <th className="custom-th" >TOTAL AMOUNT</th>
                                                            <th className="custom-th" >DELETE</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                                        {
                                                            buyerReqWiseDispatchNoteItems?.map((eachBuyerReqItem, index) => {
                                                                return (
                                                                    <DispatchNoteItems
                                                                        buyerReqItem={eachBuyerReqItem}
                                                                        buyerReqWiseDispatchNoteItems={buyerReqWiseDispatchNoteItems}
                                                                        setBuyerReqWiseDispatchNoteItems={setBuyerReqWiseDispatchNoteItems}
                                                                    />
                                                                )
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='hr-line'></div>
                                </div>
                            </div>
                    }
                </>
            }
            <div className='flex justify-content-end flex-row'>
                <Button className="small-btn" label="Create Preview Invoice" onClick={handleSubmitCreateReplaceProducts} disabled={isReplaceItems} />
            </div>
            <Dialog header="Replace Item" className='pi-punch-dialog' visible={isReplaceItemsVisible} style={{ width: '60vw', minHeight: '50vh', backgroundColor: '#f8f8f8' }} onHide={() => setIsReplaceItemsVisible(false)}>
                <ReplacementItems
                    selectedReplaceBuyerReqItems={selectedReplaceBuyerReqItems}
                    handleReplacementItem={handleReplacementItem}
                />
            </Dialog>
        </div>
    );

}

export default CreateInvoice;